import React from "react";
import SectionCTA from "../sections/SectionCTA";
import { Link } from "react-router-dom";
import { FaPenNib, FaFilm } from "react-icons/fa";
import { usePrezentacija } from "../context/PrezentacijaContext";

/**
 * Landing page for e-documents campaign (SEF + e-otpremnice).
 * Route: /e-dokumenti  (BrowserRouter basename="/poslovni-softver")
 *
 * Notes:
 * - Replace the image paths with your real screenshots when ready.
 * - This page reuses existing global CSS classes (section-hero, container, grid, etc.).
 */
function EDokumenti() {
  const { openModal } = usePrezentacija();
  return (
    <>
      {/* HERO */}
      <section className="section-hero" id="start">
        <div className="hero">
          <div className="hero-text-box">
            <h1 className="heading-primary">Pošaljite e-fakturu i e-otpremnicu sa dva klika</h1>

            <p className="hero-description">
              Pošaljite fakturu na <strong>SEF</strong> ili otpremnicu na portal{" "}
              <strong>e-otpremnice</strong> direktno iz Akord softvera.
              <br />
              <br />
              <strong>Faktura – klik. Otpremnica – klik. I gotovo.</strong>
              <br />
              <br />
              Uvek sve – u vašem softveru.
            </p>

            <div className="hero-cta-btns">
              <button className="btn btn--full" onClick={openModal}>
                Zakažite besplatan demo <FaPenNib className="icon" />
              </button>
              <a href="#kako-radi" className="btn btn--outline">
                Kako radi
              </a>
            </div>
          </div>

          <div className="hero-img-box">
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
              <div className="edok-video-hint">
                <span>Za više detalja pogledajte video ispod</span>
                <span className="edok-video-hint-arrow">👇</span>
              </div>
              <div style={{ position: "relative", paddingBottom: "56.25%", height: 0, width: "100%", overflow: "hidden", borderRadius: "12px" }}>
                <iframe
                  src="https://www.youtube.com/embed/lp7UiebWU14"
                  title="Akord softver – e-dokumenti"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PROBLEM */}
      <section className="section-how" id="problem">
        <div className="container">
          <span className="subheading">Problem</span>
          <h2 className="heading-secondary">Zašto radite duplo?</h2>

          <div className="grid grid--2-cols grid--center-v">
            <div className="step-text-box">
              <h3 className="heading-tertiary">
                Napravite dokument, a zatim prijava na neki od portala.
              </h3>
              <p className="step-description">
                Različiti dokumenti, isti problem – portal.
                <br />
                <strong>SEF.</strong>
                <br />
                <strong>e-Otpremnice.</strong>
                <br />
                Ponovo - Još jedan unos.
              </p>
              <p className="step-description">
                Dupli unos oduzima vreme i povećava rizik od greške.
                <br />
                Elektronski dokumenti su obaveza —{" "}
                <strong>dupli rad nije.</strong>
              </p>
            </div>

            <div className="step-img-box">
              {/* Optional illustrative image */}
              <picture>
                <source
                  srcSet="/poslovni-softver/img/landing/e-dokumenti/edok-problem.webp"
                  type="image/webp"
                />
                <img
                  src="/poslovni-softver/img/landing/e-dokumenti/edok-problem.png"
                  className="step-img"
                  alt="Portal i dupli unos"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
        </div>
      </section>

      {/* SOLUTION: TWO CLICKS */}
      <section className="section-meals" id="kako-radi">
        <div className="container center-text">
          <span className="subheading">Rešenje</span>
          <h2 className="heading-secondary">U Akordu – princip je isti.</h2>
        </div>

        <div className="container grid grid--3-cols margin-bottom-md">
          <div className="meal">
            <div className="meal-content">
              <p className="meal-title">
                <strong>Faktura – klik</strong>
              </p>
              <p className="meal-attribute">
                Pošaljite fakturu na <strong>SEF</strong> direktno iz
                transakcije.
              </p>
            </div>
          </div>

          <div className="meal">
            <div className="meal-content">
              <p className="meal-title">
                <strong>Otpremnica – klik</strong>
              </p>
              <p className="meal-attribute">
                Pošaljite otpremnicu na <strong>portal e-Otpremnice</strong>{" "}
                direktno iz transakcije.
              </p>
            </div>
          </div>

          <div className="meal">
            <div className="meal-content">
              <p className="meal-title">
                <strong>I gotovo</strong>
              </p>
              <p className="meal-attribute">
                Bez dodatnih prijava. Bez prepisivanja. Sve ostaje u sistemu.
              </p>
            </div>
          </div>
        </div>
        <div className="container grid grid--2-cols grid--center-v">
          <div className="step-img-box">
            <picture>
              <source
                srcSet="/poslovni-softver/img/landing/e-dokumenti/edok-invoice-click.webp"
                type="image/webp"
              />
              <img
                src="/poslovni-softver/img/landing/e-dokumenti/edok-invoice-click.png"
                className="step-img"
                alt="Faktura – klik (slanje na SEF)"
                loading="lazy"
              />
            </picture>
          </div>

          <div className="step-img-box">
            <picture>
              <source
                srcSet="/poslovni-softver/img/landing/e-dokumenti/edok-delivery-click.webp"
                type="image/webp"
              />
              <img
                src="/poslovni-softver/img/landing/e-dokumenti/edok-delivery-click.png"
                className="step-img"
                alt="Otpremnica – klik (slanje na portal)"
                loading="lazy"
              />
            </picture>
          </div>
        </div>
        <div className="container center-text margin-bottom-md">
          <button className="btn btn--full margin-right-sm" onClick={openModal}>
            Saznajte više...
          </button>
        </div>
      </section>

      {/* CONTROL */}
      <section className="section-testimonials" id="kontrola">
        <div className="container">
          <span className="subheading">Kontrola</span>
          <h2 className="heading-secondary">Uvek sve – u vašem softveru.</h2>

          <div className="grid grid--2-cols grid--center-v">
            <div>
              <ul className="list">
                <li className="list-item">
                  Pregled poslatih i primljenih e-faktura za bilo koji period
                </li>
                <li className="list-item">
                  Zbirni pregled e-otpremnica sa jasnim statusima
                </li>
                <li className="list-item">Bez skakanja sa sistema na sistem</li>
              </ul>
            </div>

            <div className="step-img-box">
              <picture>
                <source
                  srcSet="/poslovni-softver/img/landing/e-dokumenti/edok-statuses.webp"
                  type="image/webp"
                />
                <img
                  src="/poslovni-softver/img/landing/e-dokumenti/edok-statuses.png"
                  className="step-img"
                  alt="Pregled i statusi e-dokumenata"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
        </div>
        <div className="container center-text margin-top-md">
          <button className="btn btn--outline" onClick={openModal}>
            Zakažite kratku prezentaciju
          </button>
        </div>
      </section>

      {/* AUTOMATIC RECEIPT */}
      <section className="section-how" id="prijem">
        <div className="container">
          <span className="subheading">Prijem robe</span>
          <h2 className="heading-secondary">Primili ste e-otpremnicu?</h2>

          <div className="grid grid--2-cols grid--center-v">
            <div className="step-text-box">
              <h3 className="heading-tertiary">
                Automatsko povlačenje podataka
              </h3>
              <p className="step-description">
                Akord automatski povlači podatke sa portala i formira prijemnicu
                ili drugi dokument.
              </p>
              <br />
              <p className="step-description">
                <strong>Bez ručnog unosa. Bez grešaka.</strong>
              </p>
            </div>

            <div className="step-img-box">
              <picture>
                <source
                  srcSet="/poslovni-softver/img/landing/e-dokumenti/edok-receipt.webp"
                  type="image/webp"
                />
                <img
                  src="/poslovni-softver/img/landing/e-dokumenti/edok-receipt.png"
                  className="step-img"
                  alt="Automatsko formiranje prijemnice"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
        </div>
      </section>
{/*       
      <SectionCTA /> */}

     
    </>
  );
}

export default EDokumenti;
